//
//
//
//
//
//
//
//
//

export default {
  name: 'TextTruncate',
  props: {
    text: {
      type: String,
      required: true,
    },
    reverse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showReverseDots: false,
      initTruncateDebounced: null,
    };
  },
  mounted() {
    setTimeout(() => {
      this.initTruncate();
    });
    this.initTruncateDebounced = _.debounce(this.initTruncate, 200);
    window.addEventListener('resize', this.initTruncateDebounced);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.initTruncateDebounced);
  },
  methods: {
    initTruncate() {
      if (this.reverse) {
        const wrapper = this.$refs.wrapper.offsetWidth;
        const text = this.$refs.text.offsetWidth;
        console.log('========== initTruncate ', text, wrapper);
        this.showReverseDots = text > wrapper;
      }
    },
  },
};
